import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { MenuIcon, CurrencyDollarIcon } from '@heroicons/react/outline';
import driLogo from '../assets/dri_logo.png';
import logo from '../assets/logo.svg';
import liveIcon from '../assets/live.svg';
import kpiIcon from '../assets/Metallurgical.svg';
import monthIcon from '../assets/monthtodate.svg';
import labIcon from '../assets/lab.svg';
import checkIcon from '../assets/checks.svg';
import setupIcon from '../assets/setup.svg';

const links = [
  { to: '/live', label: 'Live Dashboard', icon: liveIcon },
  { to: '/kpi', label: 'Metallurgical & KPI', icon: kpiIcon },
  { to: '/production', label: 'Month To Date', icon: monthIcon },
  { to: '/lab', label: 'Lab Inspections', icon: labIcon },
  { to: '/process-checks', label: 'Equipment Checks', icon: checkIcon },
  { to: '/drive', label: 'DRiVE', iconComponent: CurrencyDollarIcon },
  { to: '/setup', label: 'Account Setup', icon: setupIcon },
];

// The old full-page "DRi X" AI link is intentionally not shown in the nav — the
// AI assistant is now the floating DRi-X pop-up bubble (DriXWidget) that appears
// on every page. Re-add a nav entry here if the standalone page is ever restored.

function Sidebar() {
  const [open, setOpen] = useState(true);
  return (
    <div
      className={`bg-[#0d2c3d] text-white shadow-lg flex flex-col h-screen border-r border-white/10 ${
        open ? 'w-56' : 'w-14'
      } transition-all duration-300`}
    >
      <div className={`flex items-center ${open ? 'justify-between' : 'justify-center'} p-4`}>
        {open && <img src={logo} alt="logo" className="h-6" />}
        <button onClick={() => setOpen(!open)}>
          <MenuIcon className="h-6 w-6" />
        </button>
      </div>
      <div className="border-b border-white/10"></div>
      <nav className="mt-4 space-y-2 flex-1 overflow-y-auto">
        {links.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            aria-label={link.to === '/drix' ? 'DRi X' : undefined}
            title={link.to === '/drix' ? 'DRi X' : undefined}
            className={({ isActive }) =>
              `relative block ${open ? 'mx-2 px-4' : 'mx-1 px-1'} py-2 rounded-md text-sm hover:bg-[#0159B2]/50 ${
                isActive
                  ? 'bg-[#0159B2] before:content-[""] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1 before:bg-green-500 before:rounded-full'
                  : ''
              }`
            }
          >
            <div className="flex items-center space-x-2 justify-left min-h-[20px]">
              {link.logo ? (
                <img src={link.logo} alt="DRi X" className={`${open ? 'h-5' : 'h-4'} w-auto`} />
              ) : link.iconComponent ? (
                <link.iconComponent className="h-5 w-5" aria-hidden="true" />
              ) : (
                <img src={link.icon} alt="" className="h-5 w-5" />
              )}
              {open && !link.logo && <span>{link.label}</span>}
            </div>
          </NavLink>
        ))}
      </nav>

      {open && (
        <div className="mt-auto">
          <div className="border-t border-white/10 mb-4"></div>
          <div className="p-4 flex items-center justify-center space-x-2">
            <span className="italic text-sm text-gray-300">Powered by</span>
            <img src={driLogo} alt="DRI" className="h-8" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
